export const slugify = (value) => {
  //const value = args.join(" ");

  return value
    .normalize("NFD") // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/\-/g, "_") // separator
    .replace(/[^a-z0-9 _]/g, "") // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, "_"); // separator
};
